enum OtherMachineStatusConstants {
  NEVER_SEEN = 'NEVER_SEEN',
  NON_ACTIVATED = 'NON_ACTIVATED',
  NOT_READY = 'NOT_READY',
  POSSIBLY_LOST = 'POSSIBLY_LOST',
  UNKNOWN = 'UNKNOWN',

  // Inventory Status V2
  NOT_CONNECTED = 'NOT_CONNECTED',
  // Inventory Status V3
  NO_MACHINE_SENSOR = 'NO_MACHINE_SENSOR',

  ON_THE_SHELF = 'ON_THE_SHELF',
  OUT_WORKING = 'OUT_WORKING',
}

export default OtherMachineStatusConstants;
